export default __webpack_public_path__ + "static/media/About.e6b165b0.md";